import { config } from '@onflow/fcl'

config({
    'accessNode.api':'https://access-testnet.onflow.org',
    'discovery.wallet': `https://fcl-discovery.onflow.org/testnet/authn`,
    'flow.network': 'emulator',
    'app.detail.icon': 'https://avatars.githubusercontent.com/u/62387156?v=4',
    'app.detail.title': 'WriteDaily',
})